<div class="form-wrapper d-flex flex-column gap-2">
    <h3 style="font-weight: 700; ">
        Forgot your password
    </h3>

    <p style="font-size: smaller; margin-bottom: 20px;">Please enter the email address you'd like your password reset information sent to</p>

    <form [formGroup]="form" (ngSubmit)="openConfirmModal()">
        <div class="form-fields">
            <div class="row g-3">
                <div class="col-md-12 field">
                    <label for="name" style="font-size: 11px;" class="required">
                        Enter email address
                    </label>

                    <input type="text" placeholder="Enter email" class="form-control mt-0" formControlName="email"
                        maxlength="100">
                    <app-error-message [form]="form" controlName="email" label="Email"
                        [showErrorMessage]="showErrorMessages"></app-error-message>
                </div>
            </div>

        </div>

        <div class="modal-actions-wrapper flex-column align-items-center">
            <button type="submit" class="custom-btn-primary w-100" [disabled]="
            form.pristine || form.invalid || isSubmitting
          ">
                <ng-container *ngIf="!isSubmitting; else loadingTemplate">
                    <span>Request reset link</span>
                </ng-container>
                <ng-template #loadingTemplate>
                    <span>Sending password reset link...</span>
                    <div class="spinner-light"></div>
                </ng-template>
            </button>

            <span style="color: #0d6efd; text-decoration: underline; cursor: pointer;" (click)="closeModal()">Go back to login</span>


        </div>
    </form>
</div>